import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { COMPONENTS } from '.';
import { LandingPageRouterModule } from './landing-page-routing.module';
import { SharedModule } from '../shared/shared.module';
import { LandingPageService } from './landing-page.service';
import { AuthModule } from '../auth/auth.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	declarations: [COMPONENTS],
	imports: [
		CommonModule,
		LandingPageRouterModule,
		FormsModule,
		ReactiveFormsModule,
		AuthModule,
		SharedModule,
		MatDialogModule,
		MatTooltipModule
	],
	providers: [
		LandingPageService
	],
	exports: [
		SharedModule
	]
})
export class LandingPageModule {}
